import { render, staticRenderFns } from "./SetteiListPage.vue?vue&type=template&id=8204f214&scoped=true&"
import script from "./SetteiListPage.vue?vue&type=script&lang=ts&"
export * from "./SetteiListPage.vue?vue&type=script&lang=ts&"
import style0 from "./SetteiListPage.vue?vue&type=style&index=0&id=8204f214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8204f214",
  null
  
)

export default component.exports